export function getWorkspaceCompletion(workspace: any): boolean {
  const steps = workspace.reportWorkflowWorkspaceSteps.nodes

  if (steps.some((step: any) => step.status === 'incomplete')) {
    return false
  }

  return true
}
